import React from 'react'
import PropTypes from 'prop-types'
import ActionModal from './action-modal'

export default function ModalAlert ({ onClose, ...props }) {
  const handleLeftClick = () => {
    onClose && onClose()
  }

  return (
    <ActionModal
      className="modal_alert"
      showCloseButton={true}
      leftButtonLabel="Dismiss"
      onLeftClick={handleLeftClick}
      onClose={onClose}
      {...props}
    />
  )
}

ModalAlert.propTypes = {
  onClose: PropTypes.func
}
